import { writable, derived } from 'svelte/store';
import type { Environment, TimelineEvent, TimelineGroup, SearchState } from '../types/debugger';
import { fetchTimeline } from '../services/debugger-client';

export const searchState = writable<SearchState>({
  query: '',
  searchType: 'advertiser_id',
  environment: 'Beta',
  loading: false,
  error: null,
});

export const timelineEvents = writable<TimelineEvent[]>([]);
export const selectedEventId = writable<string | null>(null);

export const timelineGroups = derived(timelineEvents, ($events) => {
  const groups = new Map<string, TimelineEvent[]>();
  for (const event of $events) {
    const date = new Date(event.timestamp).toLocaleDateString('en-US', {
      weekday: 'short', month: 'short', day: 'numeric',
    });
    if (!groups.has(date)) groups.set(date, []);
    groups.get(date)!.push(event);
  }
  return Array.from(groups.entries()).map(([date, events]) => ({
    date,
    events: events.sort((a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime()),
  })) as TimelineGroup[];
});

export const selectedEvent = derived(
  [timelineEvents, selectedEventId],
  ([$events, $id]) => $events.find(e => e.id === $id) ?? null,
);

export async function search(query: string, searchType: SearchState['searchType'], env: Environment) {
  searchState.update(s => ({ ...s, query, searchType, environment: env, loading: true, error: null }));
  try {
    const events = await fetchTimeline(env, query);
    timelineEvents.set(events);
    if (events.length > 0) selectedEventId.set(events[0].id);
  } catch (e: any) {
    searchState.update(s => ({ ...s, error: e.message }));
  } finally {
    searchState.update(s => ({ ...s, loading: false }));
  }
}
